export default "__VITE_ASSET__DXZ8S3el__"